import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/da20u3tv7gurs51ef2u0";

export default function SubscribeForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = new FormData(form).get("website_alt");
    const currentEmail = email;

    setStatus("loading");
    setFormError("");

    if (honeypot && String(honeypot).trim() !== "") {
      setStatus("success");
      form.reset();
      setEmail("");
      return;
    }

    const payload = new FormData(form);
    const trimmed = currentEmail.trim();
    if (trimmed) payload.set("email", trimmed);

    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: payload,
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || "";
      const isSpam = /spam/i.test(responseText) || /spam/i.test(serverMsg);

      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
        setEmail("");
      } else {
        setStatus("error");
        setFormError(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <form id="subscribe-form" data-readdy-form onSubmit={onSubmit} className="mx-auto w-full max-w-xl">
      <div className="flex flex-col gap-3 sm:flex-row">
        <label htmlFor="subscribe-email" className="sr-only">
          邮箱地址
        </label>
        <input
          id="subscribe-email"
          type="email"
          name="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="输入邮箱，每周收一次治愈推荐"
          autoComplete="email"
          className="flex-1 rounded-full border border-background-300 bg-background-50 px-5 py-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="btn-primary px-6 py-3 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === "loading" ? "提交中..." : "订阅频道"}
        </button>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      {status === "success" && (
        <p className="mt-3 flex items-center justify-center gap-1 text-sm font-medium text-secondary-800">
          <i className="ri-checkbox-circle-fill" aria-hidden="true"></i>
          订阅成功！欢迎加入喵趣大家庭，期待与你一起追更。
        </p>
      )}
      {status === "error" && formError && (
        <p className="mt-3 flex items-center justify-center gap-1 text-sm font-medium text-accent-700">
          <i className="ri-error-warning-fill" aria-hidden="true"></i>
          {formError}
        </p>
      )}
    </form>
  );
}